export const REQUEST_SINGLE_CLIENT_DETAILS = "REQUEST_SINGLE_CLIENT_DETAILS";
export const SET_SINGLE_CLIENT_DETAILS = "SET_SINGLE_CLIENT_DETAILS";
export const REVOKE_SINGLE_CLIENT_DETAILS = "REVOKE_SINGLE_CLIENT_DETAILS";
export const RESET_SINGLE_CLIENT_DETAILS = "RESET_SINGLE_CLIENT_DETAILS";

export const REQUEST_SINGLE_CLIENT_ROLES = "REQUEST_SINGLE_CLIENT_ROLES";
export const SET_SINGLE_CLIENT_ROLES = "SET_SINGLE_CLIENT_ROLES";
export const REVOKE_SINGLE_CLIENT_ROLES = "REVOKE_SINGLE_CLIENT_ROLES";
export const RESET_SINGLE_CLIENT_ROLES = "RESET_SINGLE_CLIENT_ROLES";

export const REQUEST_SINGLE_CLIENT_SALES = "REQUEST_SINGLE_CLIENT_SALES";
export const SET_SINGLE_CLIENT_SALES = "SET_SINGLE_CLIENT_SALES";
export const REVOKE_SINGLE_CLIENT_SALES = "REVOKE_SINGLE_CLIENT_SALES";
export const RESET_SINGLE_CLIENT_SALES = "RESET_SINGLE_CLIENT_SALES";

export const REQUEST_SINGLE_CLIENT_NOTES = "REQUEST_SINGLE_CLIENT_NOTES";
export const SET_SINGLE_CLIENT_NOTES = "SET_SINGLE_CLIENT_NOTES";
export const REVOKE_SINGLE_CLIENT_NOTES = "REVOKE_SINGLE_CLIENT_NOTES";
export const RESET_SINGLE_CLIENT_NOTES = "RESET_SINGLE_CLIENT_NOTES";

export const REQUEST_ADD_SINGLE_CLIENT_SALE = "REQUEST_ADD_SINGLE_CLIENT_SALE";
export const GRANT_ADD_SINGLE_CLIENT_SALE = "GRANT_ADD_SINGLE_CLIENT_SALE";
export const REVOKE_ADD_SINGLE_CLIENT_SALE = "REVOKE_ADD_SINGLE_CLIENT_SALE";
export const RESET_ADD_SINGLE_CLIENT_SALE = "RESET_ADD_SINGLE_CLIENT_SALE";

export const REQUEST_REMOVE_SINGLE_CLIENT_DATA =
  "REQUEST_REMOVE_SINGLE_CLIENT_DATA";
export const GRANT_REMOVE_SINGLE_CLIENT_DATA =
  "GRANT_REMOVE_SINGLE_CLIENT_DATA";
export const REVOKE_REMOVE_SINGLE_CLIENT_DATA =
  "REVOKE_REMOVE_SINGLE_CLIENT_DATA";
export const RESET_REMOVE_SINGLE_CLIENT_DATA =
  "RESET_REMOVE_SINGLE_CLIENT_DATA";

export const REQUEST_UPDATE_SINGLE_CLIENT_DATA =
  "REQUEST_UPDATE_SINGLE_CLIENT_DATA";
export const GRANT_UPDATE_SINGLE_CLIENT_DATA =
  "GRANT_UPDATE_SINGLE_CLIENT_DATA";
export const REVOKE_UPDATE_SINGLE_CLIENT_DATA =
  "REVOKE_UPDATE_SINGLE_CLIENT_DATA";
export const RESET_UPDATE_SINGLE_CLIENT_DATA =
  "RESET_UPDATE_SINGLE_CLIENT_DATA";

export const SET_SINGLE_CLIENT_ACTIVE_SALES_KEY =
  "SET_SINGLE_CLIENT_ACTIVE_SALES_KEY";
export const RESET_SINGLE_CLIENT_ACTIVE_SALES_KEY =
  "RESET_SINGLE_CLIENT_ACTIVE_SALES_KEY";

export const REQUEST_UPDATE_SINGLE_CLIENT_SALE =
  "REQUEST_UPDATE_SINGLE_CLIENT_SALE";
export const GRANT_UPDATE_SINGLE_CLIENT_SALE =
  "GRANT_UPDATE_SINGLE_CLIENT_SALE";
export const REVOKE_UPDATE_SINGLE_CLIENT_SALE =
  "REVOKE_UPDATE_SINGLE_CLIENT_SALE";
export const RESET_UPDATE_SINGLE_CLIENT_SALE =
  "RESET_UPDATE_SINGLE_CLIENT_SALE";

export const REQUEST_REMOVE_SINGLE_CLIENT_SALE =
  "REQUEST_REMOVE_SINGLE_CLIENT_SALE";
export const GRANT_REMOVE_SINGLE_CLIENT_SALE =
  "GRANT_REMOVE_SINGLE_CLIENT_SALE";
export const REVOKE_REMOVE_SINGLE_CLIENT_SALE =
  "REVOKE_REMOVE_SINGLE_CLIENT_SALE";
export const RESET_REMOVE_SINGLE_CLIENT_SALE =
  "RESET_REMOVE_SINGLE_CLIENT_SALE";

export const SET_SINGLE_CLIENT_ACTIVE_SALE_DISPLAY =
  "SET_SINGLE_CLIENT_ACTIVE_SALE_DISPLAY";
export const RESET_SINGLE_CLIENT_ACTIVE_SALE_DISPLAY =
  "RESET_SINGLE_CLIENT_ACTIVE_SALE_DISPLAY";

export const CHANGE_SINGLE_CLIENT_MODAL = "CHANGE_SINGLE_CLIENT_MODAL";
export const CHANGE_SINGLE_CLIENT_SALES_YEAR =
  "CHANGE_SINGLE_CLIENT_SALES_YEAR";

export const REQUEST_ADD_SINGLE_CLIENT_NOTE = "REQUEST_ADD_SINGLE_CLIENT_NOTE";
export const GRANT_ADD_SINGLE_CLIENT_NOTE = "GRANT_ADD_SINGLE_CLIENT_NOTE";
export const REVOKE_ADD_SINGLE_CLIENT_NOTE = "REVOKE_ADD_SINGLE_CLIENT_NOTE";
export const RESET_ADD_SINGLE_CLIENT_NOTE = "RESET_ADD_SINGLE_CLIENT_NOTE";

export const REQUEST_REMOVE_SINGLE_CLIENT_NOTE =
  "REQUEST_REMOVE_SINGLE_CLIENT_NOTE";
export const GRANT_REMOVE_SINGLE_CLIENT_NOTE =
  "GRANT_REMOVE_SINGLE_CLIENT_NOTE";
export const REVOKE_REMOVE_SINGLE_CLIENT_NOTE =
  "REVOKE_REMOVE_SINGLE_CLIENT_NOTE";
export const RESET_REMOVE_SINGLE_CLIENT_NOTE =
  "RESET_REMOVE_SINGLE_CLIENT_NOTE";

export const REQUEST_SELECTION_YEARS = "REQUEST_SELECTION_YEARS";
export const SET_SELECTION_YEARS = "SET_SELECTION_YEARS";
export const REVOKE_SELECTION_YEARS = "REVOKE_SELECTION_YEARS";
export const RESET_SELECTION_YEARS = "RESET_SELECTION_YEARS";

export const SET_ACTIVE_SELECTION_YEAR = "SET_ACTIVE_SELECTION_YEAR";
export const RESET_ACTIVE_SELECTION_YEAR = "RESET_ACTIVE_SELECTION_YEAR";
